import React from 'react'
import { Trans } from '@lingui/macro'

import { ButtonPrimary } from 'front-end/src/components'

const UserAdditionalInfo = ({
  user,
  handleUserForm,
  submitUserForm,
  canEdit
}) => {
  return (
    <div className="User__additional">
      <div className="form-row">
        <label htmlFor="employee_id" className="form-label">
          <Trans>Employee ID</Trans>
        </label>
        <input
          id="employee_id"
          type="text"
          defaultValue={user.employee_id}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              employee_id: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="position" className="form-label">
          <Trans>Position</Trans>
        </label>
        <input
          id="position"
          type="text"
          defaultValue={user.position}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              position: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="area" className="form-label">
          <Trans>Area</Trans>
        </label>
        <input
          id="area"
          type="text"
          defaultValue={user.area}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              area: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="location" className="form-label">
          <Trans>Location</Trans>
        </label>
        <input
          id="location"
          type="text"
          defaultValue={user.location}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              location: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="department" className="form-label">
          <Trans>Department</Trans>
        </label>
        <input
          id="department"
          type="text"
          defaultValue={user.department}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              department: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="custom_1" className="form-label">
          <Trans>Custom 1</Trans>
        </label>
        <input
          id="custom_1"
          type="text"
          defaultValue={user.custom_1}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              custom_1: e.currentTarget.value
            })
          }
        />
      </div>

      <div className="form-row">
        <label htmlFor="custom_2" className="form-label">
          <Trans>Custom 2</Trans>
        </label>
        <input
          id="custom_2"
          type="text"
          defaultValue={user.custom_2}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              custom_2: e.currentTarget.value
            })
          }
        />
      </div>
      <div className="form-row">
        <label htmlFor="custom_3" className="form-label">
          <Trans>Custom 3</Trans>
        </label>
        <input
          id="custom_3"
          type="text"
          defaultValue={user.custom_3}
          disabled={!canEdit}
          className="form-textInput"
          onChange={(e) =>
            handleUserForm({
              custom_3: e.currentTarget.value
            })
          }
        />
      </div>
      {canEdit && (
        <div className="User__submit">
          <ButtonPrimary
            onClick={async () => {
              submitUserForm()
            }}
          >
            <Trans>Update details</Trans>
          </ButtonPrimary>
        </div>
      )}
    </div>
  )
}

export default UserAdditionalInfo
